import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

//search document
export type SearchDocumentRequest = {
    userID: number
    recID: number | null
    submittedTypeID?: string | null
}

export type SearchDocumentResponse = {
    documentID: number
    name: Translation
    shortName: Translation
    code: string
    no: number
    rec: {
        id: number
        name: Translation
    }
    order: number
    documentRequire: boolean
}

type Translation = {
    th: string
    en: string
}

export type Order = 'desc' | 'asc'

//update document
export type UpdateDocumentRequest = {
    nameTH: string | null
    nameEN: string | null
    shortNameTH: string | null
    shortNameEN: string | null
    code: string | null
    submittedTypeID: string[] | null
    recID: number | null
    userID: number
    isDisplayDocument: boolean | null
    documentInfo: UplodeFileDocType[]
}

export type UpdateDocumentResponse = {
    message: string
    status?: number
}

//get document id
export type GetDocumentRequest = {
    documentID: number
}

export type GetDocumentResponse = {
    documentID?: number | null
    nameTH: string | null
    nameEN: string | null
    shortNameTH: string | null
    shortNameEN: string | null
    code: string | null
    submittedTypeID: string[] | null
    isDisplayDocument: boolean | null
    documentInfo: UplodeFileDocType[]
}

export type AddDocumentRequest = {
    nameTH: string | null
    nameEN: string | null
    shortNameTH: string | null
    shortNameEN: string | null
    code: string | null
    submittedTypeID: string[] | null
    recID: number | null
    userID: number | null
    isDisplayDocument: boolean | null
    documentInfo: UplodeFileDocType[]
}

export type AddDocumentResponse = {
    message: string
    status?: number
}

export type FileList = {
    documentTopicID: number | null
    fileID: string | null
    fileToken: string | null
    filename: string | null
}

export type UplodeFileDocType = {
    uploadFileObj?: {
        documentTopicID: number | null
        fileList: FileList[]
    }
}

export type DocumentResponseSearch = {
    data: SearchDocumentResponse[]
    total: number
}

export const useSettingDocument = () => {
    const callApi = useCallApi()

    const getSearchSettingDocument = async (values: SearchDocumentRequest) => {
        const url = new URL(umServiceURL.getSearchSettingDocument)
        url.searchParams.set('userID', values?.userID.toString())
        values?.recID && url.searchParams.set('recID', values.recID.toString())
        // url.searchParams.set('userID', '1')
        // values?.recID && url.searchParams.set('recID', '2')
        values?.submittedTypeID && url.searchParams.set('submittedTypeID', String(values.submittedTypeID))
        const { data } = await callApi.axiosGet<DocumentResponseSearch>({
            url: url,
        })

        return data
    }

    const putEditSettingDocument = async (values: UpdateDocumentRequest, documentID: number) => {
        const { data } = await callApi.axiosPut<UpdateDocumentResponse>({
            url: `${umServiceURL.getSettingDocument}${documentID}`,
            params: values,
        })

        return data
    }

    const postSettingDocument = async (values: AddDocumentRequest) => {
        const { data } = await callApi.axiosPost<AddDocumentResponse>({
            url: `${umServiceURL.postSettingDocument}`,
            params: { ...values },
        })

        return data
    }

    const getSettingDocument = async (values: GetDocumentRequest) => {
        const url = new URL(umServiceURL.getSettingDocument)
        url.searchParams.set('documentID', `${values.documentID}`)
        const { data } = await callApi.axiosGet<GetDocumentResponse>({
            url: `${umServiceURL.getSettingDocument}${values.documentID}`,
        })

        return data
    }

    const putOrderSettingDocument = async (values: number[], userID: number, submittedType: string | null) => {
        const { data } = await callApi.axiosPut<UpdateDocumentResponse>({
            url: `${umServiceURL.putOrderSettingDocument}${submittedType}`,
            params: { listID: values },
        })

        return data
    }

    const postDocRequire = async (values: { documentID: number; order: number }) => {
        const { data } = await callApi.axiosPost<AddDocumentResponse>({
            url: `${umServiceURL.docRequire}`,
            params: { ...values },
        })

        return data
    }

    return {
        getSearchSettingDocument,
        putEditSettingDocument,
        getSettingDocument,
        postSettingDocument,
        putOrderSettingDocument,
        postDocRequire,
    }
}
